import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const BabyChildOutline = createIcon({
  displayName: 'BabyChildOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M15.889 10.853l-2.34114e-08 3.05599e-08c-.278956.364132-.708393.58161-1.167.591l1.27046e-08 3.3269e-10c-.457676-.011985-.885753-.22896-1.166-.591"></path>
        <path d="M10.444 10.853l-3.38106e-08 4.4136e-08c-.278738.363861-.707747.581309-1.166.591l-4.66963e-08-1.22059e-09c-.457958-.0119705-.886347-.228918-1.167-.591"></path>
        <path d="M12 20.333l-4.94452e-08 2.40661e-11c3.7529-.00182649 7.04119-2.51298 8.031-6.133l1.93597e-07-2.10917e-08c1.21337-.132192 2.08984-1.22299 1.95764-2.43636 -.112332-1.03107-.926571-1.84531-1.95765-1.95764l1.82009e-07 6.67733e-07c-1.20899-4.4354-5.78467-7.05092-10.2201-5.84193 -2.84446.775336-5.0666 2.99747-5.84193 5.84193l-1.23762e-07 1.34834e-08c-1.21337.132192-2.08984 1.22299-1.95764 2.43636 .112332 1.03107.926571 1.84531 1.95765 1.95764l2.99212e-07 1.0943e-06c.989811 3.62002 4.2781 6.13117 8.031 6.133Z"></path>
        <path d="M14.222 15.007l6.30406e-08-5.4997e-08c-1.27314 1.11069-3.17086 1.11069-4.444 1.46263e-07"></path>
        <path d="M10.889 7.191l1.38294e-07 1.00884e-07c.322751.235442.711503.36316 1.111.365l-4.41678e-09 1.00169e-10c1.07392-.0243554 1.92476-.914682 1.9004-1.9886 -.023578-1.03964-.860761-1.87682-1.9004-1.9004"></path>
      </g>
      <rect width="24" height="24" fill="none"></rect>
    </>
  ),
})

const BabyChild: FC<CustomIconProps> = (props) => {
  switch (props.variant) {
  default:
    return <CustomIcon as={BabyChildOutline} {...props} />
  }
}

export default memo(BabyChild)
